import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import exclamation from '../../../assets/svg/exclamationmark.svg'
import {
    ButtonAction,
    ButtonsContainer,
    ContentContainer,
    dialogPanel
} from './styles'

interface ArchiveWarningProps {
    handleCloseModal: () => void
    isOpen: boolean
    submit: () => void
}

const ArchiveWarning: React.FC<ArchiveWarningProps> = ({
    handleCloseModal,
    isOpen,
    submit
}) => {
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-ArchiveNotificationWarningModal"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <ContentContainer>
                                        <img
                                            src={exclamation}
                                            alt="exclamation-svg"
                                            width={66}
                                        />
                                        <p className="text-yellow font-semibold text-base mt-4">
                                            Notificação em tratamento
                                        </p>
                                        <span className="max-w-[416px] text-center mt-4">
                                            Tem certeza que deseja arquivar uma
                                            notificação que está em tratamento?
                                            Ela será arquivada e não será
                                            possível desfazer esta ação.
                                        </span>
                                        <ButtonsContainer>
                                            <ButtonAction
                                                onClick={() => {
                                                    handleCloseModal()
                                                }}
                                                type="button"
                                                className="text-blueTheme text-sm"
                                            >
                                                Cancelar
                                            </ButtonAction>
                                            <ButtonAction
                                                onClick={() => {
                                                    submit()
                                                }}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                Sim, arquivar notificação
                                            </ButtonAction>
                                        </ButtonsContainer>
                                    </ContentContainer>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export { ArchiveWarning }
